import { MQ } from '../helpers/constants.js';

const index = {
    vars: {
    },

    toggleMobile: function (e) {

    },

    toggleDesktop: function (e) {

    },

    bindEvents: function () {
        //on media query change
        MQ.MD.addListener(function(e) {
            if (e.matches) {
                index.toggleDesktop();
            } else {
                index.toggleMobile();    
            }
        });
    },

    init: function () {
        console.log('index init');
        index.bindEvents();
    }
}

$(document).ready(function() {
    index.init();
});
